<template>
    <div>
        <span style="padding-right: 5px;">月份選擇:</span>
        <el-select
                placeholder="請選擇月份"
                v-model="month"
                style="margin-right: 5px;"
                @change="onMonthChange"
        >
            <el-option
                    v-for="month in availableMonths"
                    :key="month"
                    :label="month"
                    :value="month"
            ></el-option>
        </el-select>
        <span style="padding-right: 5px;">場地選擇:</span>
        <el-select
                placeholder="請選擇場地"
                v-model="roomId"
                style="margin-right: 5px;"
        >
            <el-option
                    v-for="room in drawableRooms"
                    :key="room.id"
                    :label="room.name"
                    :value="room.id"
            ></el-option>
        </el-select>
        <el-button
                icon="el-icon-refresh-right"
                @click="refresh"
                :loading="loading"

        >
            重新載入
        </el-button>
        <el-table
                :data="pagedData"
                empty-text="本月份無抽籤紀錄"
                height="610px"
                row-key="department"
        >
            <el-table-column
                label="系別"
                prop="department"></el-table-column>
            <el-table-column
                    label="詳細"
                    prop="detail"></el-table-column>
        </el-table>
        <el-pagination
                style="margin-top: 10px;"
                background
                layout="total, prev, pager, next"
                :total="currentStatistic.length"
                :page-size="pageSize"
                @current-change="page => pageChange(page, currentStatistic)"
                :current-page.sync="currentPage"
        ></el-pagination>
    </div>
</template>

<script>
    import {mapState, mapActions, mapGetters} from 'vuex';
    import pagingMixin from '../../pagingMixin';
    export default {
        name: 'DrewStatistic',
        data: () => ({
            month: undefined,
            roomId: '',
        }),
        computed:{
            ...mapState('manage', {
                statistic: state => state.drewStatistic
            }),
            ...mapState(['setting']),
            availableMonths() {
                return this.setting.months.map(m => m.month);
            },

            drawableRooms() {
                const drawableNcutRoomIds = new Set(this.setting.rooms.filter(r => r.drawable)
                    .map(r => r.ncutRoomId));
                return this.setting.ncutRooms.filter(r => drawableNcutRoomIds.has(r.id));
            },

            currentStatistic(){
                const raw = (this.statistic[this.roomId] || {});
                const data = Object.keys(raw)
                    .map(k => ({
                        department : k,
                        detail: raw[k].map(f => `${f.applicant.name}(${f.applicant.userId})-數量:${f.numOfDrew}`)
                            .join(', ')
                    }));
                return data;
            }
        },
        mixins: [pagingMixin],
        props: {
            loading: {
                type: Boolean,
                default: false
            }
        },
        methods:{
            ...mapActions('manage', {
                getStatistic: 'getDrewStatisticAction',
            }),
            ...mapActions('setting', {
                getNcutRooms: 'getNcutRoomsAction',
            }),
            async onMonthChange() {
                await this.getStatistic(this.month);
            },

            async refresh(){
                await this.getStatistic(this.month);
            }
        },
        watch:{
            setting: {
                async handler(newSetting) {
                    if (newSetting && newSetting.months && newSetting.months[0]) {
                        await this.getStatistic(newSetting.months[0].month);
                        this.month = newSetting.months[0].month;
                    }
                },
                deep: true
            },
            drawableRooms(current){
                this.roomId = ( current[0] || {}).id;
            },
            currentStatistic(current){
                this.pagedData = this.pageData(current, 1);
                this.currentPage = 1;
            }
        },
        async created() {
            await this.getStatistic(this.availableMonths[0]);
            this.month = this.availableMonths[0];
            await this.getNcutRooms();
        }

    }
</script>

<style>

</style>